import { isPlatformBrowser } from "@angular/common";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
export enum LoggedInSuperAdminKeys {
  SUPER_ADMIN_LOGGED_IN = "superAdminLoggedIn",
  ORGANISATION_DETAILS="organisationDetails",
  ORGANISATION_DATA='organisationTableData',
  ORG_USER_DATA='orgUserData'
}
@Injectable({
  providedIn: "root",
})
export class SuperAdminLoginService {
  constructor(@Inject(PLATFORM_ID) private platformId: object) { }

  getLoggedInUser(key: LoggedInSuperAdminKeys) {
    const loggedIn = isPlatformBrowser(this.platformId)
      ? JSON.parse(localStorage.getItem(!key ? LoggedInSuperAdminKeys.SUPER_ADMIN_LOGGED_IN : key))
      : "";
    return loggedIn;
  }

  setLoggedInUser(key: LoggedInSuperAdminKeys, localStorageData) {
    localStorage.setItem(key ? key : LoggedInSuperAdminKeys.SUPER_ADMIN_LOGGED_IN, JSON.stringify(localStorageData));
  }
  removeLoggedInUser(key: LoggedInSuperAdminKeys) {
    localStorage.removeItem(key ? key : '');
  }
  clearEntireStorage() {
    localStorage.clear();
    sessionStorage.clear();
  }
}

